import React from 'react';
import Icon from '../../../components/AppIcon';

const items = [
  { title: 'Small senior teams', icon: 'Users' },
  { title: 'Fast iterations', icon: 'Zap' },
  { title: 'Clear acceptance criteria', icon: 'CheckCircle' },
  { title: 'Rigorous telemetry', icon: 'Activity' },
  { title: 'Knowledge transfer so your teams can own it', icon: 'GraduationCap' }
];

const HowWeWorkSection = () => {
  return (
    <section className="py-20 relative text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex items-center space-x-3 mb-8">
          <div className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-lg backdrop-blur-sm border border-white/20">
            <Icon name="Handshake" size={20} color="white" />
          </div>
          <h2 className="text-4xl font-bold text-white">How we work</h2>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 enterprise-shadow border border-white/20">
          <ul className="grid md:grid-cols-2 gap-5">
            {items.map((item, idx) => (
              <li key={idx} className="flex items-start space-x-3">
                <div className="flex items-center justify-center w-8 h-8 bg-white/10 rounded-lg flex-shrink-0 border border-white/20">
                  <Icon name={item.icon} size={16} color="white" />
                </div>
                <span className="text-lg text-white/90">{item.title}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;


